import './PhoneNumber.less';

export const prefix = 'oc-c-phoneNumber';

export { default } from './PhoneNumber';